import Vue from 'vue'
import axios from 'axios'
import Mint from 'mint-ui'
import router from './router/index'
import * as filters from './filter/index'
import * as directives from './directive/index'
import App from './App.vue'
import _Util from './assets/js/Utils'
import _DESUtil from './assets/js/des3/des3'
import _Enums from './assets/js/enums'
import _Api from './api'
import '@babel/polyfill'

import Vuex from 'vuex'
import store from './store'
import eventBus from './eventBus'

import 'mint-ui/lib/style.css'

import VueTextareaAutosize from 'vue-textarea-autosize'

import MQTT from './assets/js/mqtt'

import Currency from 'currency.js'

// 复制粘贴
import VueClipboard from 'vue-clipboard2'

import FastClick from './assets/js/fastclick'
import VueLazyload from 'vue-lazyload'

import * as PDFJS from 'pdfjs-dist/es5/build/pdf.js'
PDFJS.GlobalWorkerOptions.workerSrc = '//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js'

Vue.use(VueLazyload, {
  preLoad: 1,
  loading: require('./assets/images/water2.png')
})
Vue.use(VueClipboard)

Vue.use(VueTextareaAutosize)

Vue.use(Vuex)

Vue.use(Mint)

// 开启debug模式
Vue.config.debug = process.env.NODE_ENV === 'development'

process.env.NODE_ENV === 'development' && !_Util.isMiniApp()
  ? (axios.defaults.headers.common['isTest'] =
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0MDIxNjMiLCJhdWQiOiJXRUlYSU4iLCJleHAiOjE2MjE3OTA5NzIsImlhdCI6MTYxNDU5MDk3MiwianRpIjoiZmQyYjAxZmItMDAyOS00ZjU4LWE0ZDctNGMwZjMxYzkxYWI1In0.ecPfbyW5qygS1A6KVqEtMIm2Tj7lxxsTHSP2zRyeEcQ')
  : null
// if (window.top.location.href.indexOf('wx.hotmsg.cn') != -1 || window.top.location.href.indexOf('localhost') != -1) {
//   axios.defaults.headers.common['isTest'] = '123'
// }
if (_Util.isApp() && !window.location.href.includes('172.')) {
  const wxtoken = localStorage.getItem('app-token') || ''
  axios.defaults.headers['app-token'] = wxtoken
}

// axios.defaults.headers['X-B3-TraceId'] = new Date().getTime()

Vue.prototype.$http = axios
Vue.prototype._Util = _Util
Vue.prototype._Api = _Api
Vue.prototype._Enums = _Enums
Vue.prototype._DESUtil = _DESUtil
Vue.prototype.$bus = eventBus
window['$bus'] = eventBus
Vue.prototype._MQTT = MQTT
Vue.prototype.currency = Currency

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

/**
 * FastClick配置相关
 */
FastClick.attach(document.body)
FastClick.prototype.focus = function(targetElement) {
  'use strict'
  targetElement.focus()
}

const whiteList = ['fms', 'onlineCourseList', 'questionsOrAnswers', 'memberCenter'] // 默认 4个tab页面

axios.defaults.headers['authorization'] = 'Basic c2FiZXI6ZWVBNWtjY1o1Q21tTnpfb3hvTUU='
axios.defaults.headers['blade-auth'] = 'bearer ' + localStorage.getItem('wxMiniAppToken')
if (localStorage.getItem('inWxMinapp') === '1') { // 微信小程序
  axios.defaults.headers['app-token'] = localStorage.getItem('wxMiniAppToken')
}

/**
 * 路由权限控制
 */
router.beforeEach((route, from, next) => {
  const head = document.getElementsByTagName('head')[0]
  if (route.name != 'picList') {
    const str = 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
    const oMeta = document.createElement('meta')
    oMeta.id = 'userScale'
    oMeta.content = str
    oMeta.name = 'viewport'
    head.appendChild(oMeta)
  } else {
    const el = document.getElementById('userScale')
    const str = 'width=device-width,  user-scalable=yes'
    el.content = str
  }
  // debugger
  makeTitle(route.meta.title || document.title)
  if (localStorage.getItem('inWxMinapp') === '1') { // 微信小程序
    if (whiteList.includes(from.name) && !whiteList.includes(route.name)) {
      uni.navigateTo({ // eslint-disable-line
        url: `/pages/webView/webView?src=${encodeURIComponent(location.origin + route.fullPath)}`
      })
    } else {
      next()
    }
    return
  }
  if (window.top.location.href.indexOf('http://localhost') != -1 || window.top.location.href.indexOf('192.168') != -1 || window.top.location.href.indexOf('wx.hotmsg.cn') != -1 || window.top.location.href.indexOf('user.kaxiubaodian.com') != -1 || _Util.isMPaaS()) {
    next()
    return
  }

  // if (window.top.location.href.indexOf('20251124') != -1) {
  //   next()
  //   return
  // }
  if ((route.name == 'login' || route.name == 'newLogin' || route.name == 'deal' || route.name == 'followMe' || route.name == 'personInfoRight' ||
    route.name == 'shopping' || route.name == 'productDetail' || route.name == 'appSearch' || route.name == 'phoneLogin') && (_Util.isApp() || _Util.isMPaaS())) {
    next()
  } else if (route.name == 'courseList' || route.name == 'courseRecommend' || route.name == 'epidemicMap' || route.name == 'userAgreementZDNS' || route.name == 'informationProtectionZDNS' || route.name == 'userAgreementJGZ' || route.name == 'informationProtectionJGZ' || route.name == 'kaxiubaodian' || route.name == 'alert' || route.name == 'richTextID' || route.name == 'downloadFile') {
    // 不做任何微信拦截，供某些单独的项目使用
    next()
  } else {
    axios.post(_Api.POST_WXAUTH_CHECK_SESSION, {}).then((response) => {
      const ua = navigator.userAgent.toLowerCase()
      // response.data.data.versionStatus 是否审核
      _Util.setLocalStorage('isAudit', response.data.data.versionStatus || false)
      if (!response.data.data.verifyStatus) {
        if (ua.indexOf('apicloud') != -1) {
          // window.top.location.replace(_Api.HOSTRESOURCEPATH + '/v2/' + (response.data.data.versionStatus ? 'login' : 'login')+ '?fullPath='+top.location.href)
          window.top.location.replace(_Api.HOSTRESOURCEPATH + '/v2/login?fullPath=' + top.location.href)
        } else {
          const reg = new RegExp('(^|&)code=([^&]*)(&|$)')
          const r = window.top.location.search.substr(1).match(reg)
          const code = (r == null ? null : decodeURI(r[2]))
          let getSessionApi = ''
          let getAppidApi = ''
          if (ua.indexOf('wxwork') != -1) { // 企业微信
            getAppidApi = _Api.GET_WX_WORK_GGZJ_APPID
            getSessionApi = _Api.GET_WX_WORK_GGZJ_SESSION
          } else {
            getAppidApi = _Api.POST_WXAUTH_GET_APPID
            getSessionApi = _Api.POST_COMMON_GET_SEESION
          }
          if (code) {
            axios.post(getSessionApi, { code: code }).then((response) => {
              if (response.data.status == 4000) {
                // 未关注卡修宝典
                if (route.name != 'followMe') {
                  window.top.location.replace(_Api.HOSTRESOURCEPATH + '/repair/common/followMe')
                } else {
                  next()
                }
              } else if (response.data.status == 501) {
                // code无效，需重新授权卡修宝典
                axios.post(getAppidApi, {}).then((response) => {
                  if (response.data.data && response.data.data.appId) {
                    const hr = top.location.href.substr(0, top.location.href.indexOf('code=') - 1) || top.location.href
                    window.top.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + response.data.data.appId + '&redirect_uri=' + escape(hr) + '&action=viewtest&response_type=code&scope=snsapi_base&state=1#wechat_redirect')
                  }
                }).catch(function(response) {
                  _Util.ajaxError(response)
                })
              } else if (response.data.status == 6001) {
                _Util.showMsgBox(response.data.msg)
              } else {
                if (response.data.data.kllOpenId === '' || response.data.data.kllOpenId === null) {
                  axios.post(_Api.POST_GET_GETKALULIAPPID, {}).then((response) => {
                    const hr = top.location.href.substr(0, top.location.href.indexOf('code=') - 1)
                    window.top.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + response.data.data.appId + '&redirect_uri=' + escape(hr) + '&action=viewtest&response_type=code&scope=snsapi_base&state=kaluli#wechat_redirect')
                    next()
                  }).catch(function(response) {
                    _Util.ajaxError(response)
                  })
                } else {
                  _Util.setLocalStorage('kllOpenId', true)
                  // 刷新当前登录人信息
                  store.dispatch('refreshUserInfo')
                  next()
                }
              }
            }).catch(function(response) {
              _Util.ajaxError(response)
            })
          } else {
            // code不存在，获取卡修宝典授权
            axios.post(getAppidApi, {}).then((response) => {
              if (response.data.data && response.data.data.appId) {
                const hr = top.location.href.substr(0, top.location.href.indexOf('code=') - 1) || top.location.href
                window.top.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + response.data.data.appId + '&redirect_uri=' + escape(hr) + '&action=viewtest&response_type=code&scope=snsapi_base&state=1#wechat_redirect')
              }
              next()
            }).catch(function(response) {
              _Util.ajaxError(response)
            })
          }
        }
      } else {
        if (top.location.href.indexOf('state=kaluli') != -1) {
          const reg = new RegExp('(^|&)code=([^&]*)(&|$)')
          const r = window.top.location.search.substr(1).match(reg)
          const code = (r == null ? null : decodeURI(r[2]))
          axios.post(_Api.POST_GET_GETKLLOPENIDBYCODE, { code: code })
        }
        next()
      }
    }).catch(function(response) {
      _Util.ajaxError(response)
    })
  }
})

router.afterEach((to, from) => {
  // 关闭loading效果
  Mint.Indicator.close()
  // 关闭已经打开的图片浏览器
  store.commit('closeImgView')
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

document.body.oncontextmenu = function(e) {
  if (e.target.className != '_selectTrue' && e.target.nodeName !== 'INPUT' && e.target.nodeName !== 'TEXTAREA') {
    return false
  }
}
document.body.onselectstart = function(e) {
  if (e.target.parentElement.className != '_selectTrue') {
    return false
  }
}

function makeTitle(title) {
  document.title = title
}

// eslint-disable-next-line
const app = new Vue({
  router: router,
  store,
  render: h => h(App)
}).$mount('#app')
